__turbopack_context__.v({
  "headerLinks": "header-links-module-scss-module__S3RUhG__headerLinks",
});
